import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from './Divider.module.scss';

type Props = {
  classes?: string;
};

function Divider({ children, classes }: PropsWithChildren<Props>) {
  return (
    <div {...setDenaliAttribute('Divider')} className={classNames(styles.wrapper, classes)}>
      <span className={styles.line} />
      {children && <span className={styles.text}>{children}</span>}
      <span className={styles.line} />
    </div>
  );
}

export default Divider;
